module.exports = __webpack_public_path__ + "img/microsoft.eb8a27f2.svg";